<template>
	<div
		class="g-block-body-line-badge g-block-body-padding"
		:class="{
			'g-block-body-line-badge--edit': editable,
			'is-active': editable && active,
			'g-block-body-line-badge--h5': h5,
			'g-block-body-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-body-line-badge__card">
			<div class="g-block-body-line-badge__head">
				<div class="g-block-body-line-badge__line" aria-hidden="true"></div>
				<div
					class="g-block-body-line-badge__badge"
					:style="{ background: themeColor }"
				>
					<RichTextEditable
						v-if="editable"
						class="g-block-body-line-badge__title"
						fit-content
						:model-value="data.title"
						placeholder="请输入标题"
						@update:model-value="onTitleUpdate"
						@focus="onWrapClick"
					/>
					<div
						v-else
						class="g-block-body-line-badge__title"
						v-html="data.title || ''"
					></div>
				</div>
			</div>
			<RichTextEditable
				v-if="editable"
				class="g-block-body-line-badge__text"
				:model-value="data.content"
				placeholder="请输入正文"
				@update:model-value="onContentUpdate"
				@focus="onWrapClick"
			/>
			<div
				v-else
				class="g-block-body-line-badge__text"
				v-html="data.content || ''"
			></div>
		</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { bodyCardMixin } from '../shared/bodyCardMixin.js';

	export default {
		name: 'GBlockBodyLineBadge',
		components: { RichTextEditable },
		mixins: [bodyCardMixin],
	};
</script>

<style scoped lang="less">
	@import '../shared/bodyEditShell.less';

	.g-block-body-line-badge {
		.body-block-edit-shell();
	}

	.g-block-body-line-badge__card {
		background: #fff;
		box-sizing: border-box;
		border-bottom: 1px solid #e8e8e8;
	}

	.g-block-body-line-badge__head {
		position: relative;
		display: flex;
		justify-content: center;
		margin-bottom: 14px;
	}

	.g-block-body-line-badge__line {
		position: absolute;
		top: 50%;
		left: 0;
		right: 0;
		border-top: 1px solid #e8e8e8;
		transform: translateY(-50%);
		pointer-events: none;
	}

	.g-block-body-line-badge__badge {
		position: relative;
		z-index: 1;
		padding: 6px 18px;
	}

	.g-block-body-line-badge__title {
		.body-title-base();
		color: #fff;
		text-align: center;
		white-space: nowrap;

		:deep(.g-rich-text-editable__content) {
			color: #fff;
			text-align: center;
			white-space: nowrap;
		}
	}

	.g-block-body-line-badge__text {
		.body-text-base();
		color: #666;
	}

	.g-block-body-line-badge--h5 {
		.g-block-body-line-badge__card {
		}
		.g-block-body-line-badge__head { margin-bottom: 0.28rem; }
		.g-block-body-line-badge__line { height: 0.02rem; }
		.g-block-body-line-badge__badge { padding: 0.12rem 0.36rem; }
		.body-title-base--h5(~'.g-block-body-line-badge__title');
		.body-text-base--h5(~'.g-block-body-line-badge__text');
	}
</style>
